var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxIconcom = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 19",
  width: "1em",
  height: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  fill: "currentColor"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M15.055 6.255c0 .196-.078.39-.219.531l-6.719 6.72a.758.758 0 0 1-1.062 0l-3.89-3.891a.758.758 0 0 1 0-1.063L4.226 7.49a.758.758 0 0 1 1.062 0l2.297 2.304 5.125-5.133a.758.758 0 0 1 1.062 0l1.063 1.063c.14.14.219.336.219.531z",
  id: "__checkbox-icon-svg-a"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 1)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "#E87524",
  fill: "#FFF",
  fillRule: "nonzero",
  x: 0.5,
  y: 0.333,
  width: 17,
  height: 17,
  rx: 2
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  xlinkHref: "#__checkbox-icon-svga-"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#E87524",
  xlinkHref: "#__checkbox-icon-svg-a"
}))));
export default SvgCheckboxIconcom;